import React from 'react';
import './Inventory.css'

const Inventory = () => {
    return (
        <div className="inventory">
            <h2>Developer Saiak Zakarea is sleeping now.</h2>
        </div>
    );
};

export default Inventory;